<span [adminStatusColor]="status">
    {{ status }}
    @if (flags === "StoreActionRequired") {
        <mat-icon matTooltip="An action is required from the store">warning</mat-icon>
    }
</span>
